/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

type IncomeDescriptiveProps = {
  submitProps: FormSubmitProps;
};

export default function IncomeDescriptive({ submitProps }: IncomeDescriptiveProps) {
  const { handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Einnahmen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <ValidatorTextField
                label={"Wie bestreiten Sie Ihren Unterhalt?"}
                InputLabelProps={{
                  shrink: true,
                }}
                placeholder={"Bitte beschreiben Sie hier kurz, warum Sie keine Einnahmen haben und wie Sie Ihren Unterhalt bestreiten."}
                name={"incomeDescription"}
                multiline
                rows={12}
                validators={[requiredValidator("Bitte geben Sie Ihre Einnahmesitaution an.")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
